import React, { Component } from "react";
import { Accessor, ColorX, LocaleX, ResponsiveX } from "IZOX/STATIC";
import { ActivityIndicator, HStack, VStack, XText } from "IZOX/_X";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { observer } from "mobx-react";
import Breadcrumb from "shared/Breadcrumb";
import { SysConfig } from "__SYSDefault/Config";
import ContactInfo from "./_gears/ContactInfo";
import EmailForm from "./_gears/EmailForm";
import APIExpress from "__SYSDefault/APIs/APIExpress";
import HContactInfoM from "shared/HContactInfoM";
import EmailFormM from "./_gears/EmailFormM";
import FooterM from "shared/FooterM";

/**
 * @augments {Component<Props, State>}
 */
class PContactUs extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {};
  }

  componentDidMount(){
    this._setAllStates(() => {
      this._GetInfo();
    });
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(PContactUs.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    if(this.timeout) clearTimeout(this.timeout);
    if(this.interval) clearInterval(this.interval);
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  _setTimeout = (func, delay) => {
    if(this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(func, delay);
  }

  _setInterval = (func, interval) => {
    if(this.interval) clearInterval(this.interval);
    this.interval = setInterval(func, interval);
  }

  _GetInfo = async () => {
    let info = await APIExpress.WebSettings.GetInfo();
    this.setState({
      info: info
    });
  }

  renderBreadcrumb(){
    return (
      <HStack HAlign="[">
        <Breadcrumb 
          steps={[
            {
              caption: {
                EN: "Home",
                TC: "主頁"
              },
              target: "Home"
            }
          ]}
          last={{
            EN: "Contact Us",
            TC: "聯絡我們"
          }}/>
      </HStack>
    );
  }

  renderMain(){
    let {info} = this.state;
    return (
      <VStack spacing={16} width={848} HAlign="[" VAlign="^">
        <XText fontSize={32} color={ColorX.CSS("Stone")} bold>
          {LocaleX.Parse({
            EN: "Contact Us",
            TC: "聯絡我們"
          })}
        </XText>
        <HStack VAlign="^" spacing={16} HAlign="[">
          <ContactInfo info={info}/>
          <EmailForm/>
        </HStack>
      </VStack>
    );
  }

  renderNormal(){
    return (
      <VStack fullWidth>
        <VStack width={SysConfig.ContentWidth} pH={80}>
          {this.renderBreadcrumb()}
          {this.renderMain()}
        </VStack>
      </VStack>
    );
  }

  renderBreadcrumbM(){
    return (
      <HStack HAlign="[" pH={26}>
        <Breadcrumb 
          steps={[
            {
              caption: {
                EN: "Home",
                TC: "主頁"
              },
              target: "Home"
            }
          ]}
          last={{
            EN: "Contact Us",
            TC: "聯絡我們"
          }}/>
      </HStack>
    );
  }

  renderMainM(){
    let {info} = this.state;
    return (
      <VStack spacing={16} fullWidth>
        <XText fontSize={32} color={ColorX.CSS("Stone")} bold>
          {LocaleX.Parse({
            EN: "Contact Us",
            TC: "聯絡我們"
          })}
        </XText>
        <VStack VAlign="^" spacing={16} HAlign="[">
          <HContactInfoM info={info} fontSize={18}/>
          <EmailFormM/>
        </VStack>
      </VStack>
    );
  }

  renderMobile(){
    return (
      <VStack fullWidth>
        {this.renderBreadcrumbM()}
        <VStack fullWidth pH={26}>
          {this.renderMainM()}
        </VStack>
        <FooterM/>
      </VStack>
    );
  }

  render(){
    let {info} = this.state;
    if(!info){
      return (
        <VStack fullWidth fullHeight VAlign="-" HAlign="|">
          <ActivityIndicator loading size={Math.min(100, window.innerWidth * 0.5)} thickness={10}/>
        </VStack>
      );
    }
    return ResponsiveX.Split({
      0: () => this.renderMobile(),
      [SysConfig.WebUIWidth]: () => this.renderNormal()
    });
  }

}

export default observer(PContactUs);
